/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: feedback_insight.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  GetInsightDayRequest,
  GetInsightDayResponse,
  GetInsightReportRequest,
  GetInsightReportResponse,
  ListInsightDaysRequest,
  ListInsightDaysResponse,
  ListInsightFindingsRequest,
  ListInsightFindingsResponse,
  ListInsightRunsRequest,
  ListInsightRunsResponse,
  ListInsightThemesRequest,
  ListInsightThemesResponse,
  PublishInsightReportRequest,
  PublishInsightReportResponse,
  PutInsightRunRequest,
  PutInsightRunResponse,
  SaveInsightReportRequest,
  SaveInsightReportResponse,
  SetInsightFixReviewRequest,
  SetInsightFixReviewResponse,
} from '../types/feedback_insight';

export const createFeedbackInsightService = (transport: Transport) => ({
  async putInsightRun(
    request: PutInsightRunRequest,
    options: RequestOptions = {},
  ): Promise<PutInsightRunResponse> {
    const { organization_id, day, ...body } = request;
    const url = getApiPath(API_METHODS.FeedbackInsightService.PutInsightRun, {
      organization_id,
      day,
    });
    return transport.post<PutInsightRunResponse>(url, body, options);
  },

  async listInsightRuns(
    request: ListInsightRunsRequest,
    options: RequestOptions = {},
  ): Promise<ListInsightRunsResponse> {
    const { organization_id, ...params } = request;
    const url = getApiPath(API_METHODS.FeedbackInsightService.ListInsightRuns, { organization_id });
    return transport.get<ListInsightRunsResponse>(url, { params, ...options });
  },

  async listInsightFindings(
    request: ListInsightFindingsRequest,
    options: RequestOptions = {},
  ): Promise<ListInsightFindingsResponse> {
    const { organization_id, ...params } = request;
    const url = getApiPath(API_METHODS.FeedbackInsightService.ListInsightFindings, {
      organization_id,
    });
    return transport.get<ListInsightFindingsResponse>(url, { params, ...options });
  },

  async getInsightDay(
    request: GetInsightDayRequest,
    options: RequestOptions = {},
  ): Promise<GetInsightDayResponse> {
    const { day, ...params } = request;
    const url = getApiPath(API_METHODS.FeedbackInsightService.GetInsightDay, { day });
    return transport.get<GetInsightDayResponse>(url, { params, ...options });
  },

  async setInsightFixReview(
    request: SetInsightFixReviewRequest,
    options: RequestOptions = {},
  ): Promise<SetInsightFixReviewResponse> {
    const { day, ...body } = request;
    const url = getApiPath(API_METHODS.FeedbackInsightService.SetInsightFixReview, { day });
    return transport.post<SetInsightFixReviewResponse>(url, body, options);
  },

  async getInsightReport(
    request: GetInsightReportRequest,
    options: RequestOptions = {},
  ): Promise<GetInsightReportResponse> {
    const { day, ...params } = request;
    const url = getApiPath(API_METHODS.FeedbackInsightService.GetInsightReport, { day });
    return transport.get<GetInsightReportResponse>(url, { params, ...options });
  },

  async saveInsightReport(
    request: SaveInsightReportRequest,
    options: RequestOptions = {},
  ): Promise<SaveInsightReportResponse> {
    const { day, ...body } = request;
    const url = getApiPath(API_METHODS.FeedbackInsightService.SaveInsightReport, { day });
    return transport.post<SaveInsightReportResponse>(url, body, options);
  },

  async publishInsightReport(
    request: PublishInsightReportRequest,
    options: RequestOptions = {},
  ): Promise<PublishInsightReportResponse> {
    const { day, ...body } = request;
    const url = getApiPath(API_METHODS.FeedbackInsightService.PublishInsightReport, { day });
    return transport.post<PublishInsightReportResponse>(url, body, options);
  },

  async listInsightDays(
    request: ListInsightDaysRequest,
    options: RequestOptions = {},
  ): Promise<ListInsightDaysResponse> {
    const url = getApiPath(API_METHODS.FeedbackInsightService.ListInsightDays);
    return transport.get<ListInsightDaysResponse>(url, { params: request, ...options });
  },

  async listInsightThemes(
    request: ListInsightThemesRequest,
    options: RequestOptions = {},
  ): Promise<ListInsightThemesResponse> {
    const url = getApiPath(API_METHODS.FeedbackInsightService.ListInsightThemes);
    return transport.get<ListInsightThemesResponse>(url, { params: request, ...options });
  },
});

export type FeedbackInsightService = ReturnType<typeof createFeedbackInsightService>;
